export var ChangePasswordError;
(function (ChangePasswordError) {
    ChangePasswordError["NOT_AUTHORIZED"] = "NotAuthorizedException";
    ChangePasswordError["LIMIT_EXCEEDED"] = "LimitExceededException";
})(ChangePasswordError || (ChangePasswordError = {}));
export var FormFields;
(function (FormFields) {
    FormFields["CURRENT_PW"] = "currentPassword";
    FormFields["NEW_PW"] = "newPassword";
    FormFields["CONFIRM_PW"] = "confirmPassword";
})(FormFields || (FormFields = {}));
//# sourceMappingURL=oh-login-password.types.js.map
